// 广告管理
export default [
    {
      path: '/advConfig',
      name: 'advConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/advConfig.vue'], resolve)
      }
    },
    {
      path: '/advertConsultation',
      name: 'advertConsultation',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/advertConsultation.vue'], resolve)
      }
    },
    {
      path: '/crudConfig',
      name: 'crudConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/crudConfig.vue'], resolve)
      }
    },
    {
      path: '/convertRecord',
      name: 'convertRecord',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/convertRecord.vue'], resolve)
      }
    },
    {
      path: '/applyVip',
      name: 'applyVip',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/applyVip.vue'], resolve)
      }
    }
    ,
    {
      path: '/userSignScore',
      name: 'userSignScore',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/advConfig/userSignScore.vue'], resolve)
      }
    },
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/advConfig.js